<div class="padding">
    <form [formGroup]="discharge">
        <div class="flex-container">
            <div class="flex-item form-field">
                <mat-radio-group [formControlName]="'dischargeType'" [attr.aria-label]="'orders.dischargeTypeRadioOption' | transloco">
                    <mat-radio-button data-testid="total-discharge-radio-button" class="radio-button" [value]="totalDischarge">{{ 'orders.totalDischarge' | transloco }}</mat-radio-button>
                    <mat-radio-button data-testid="agreement-to-discharge-radio-button" class="radio-button" [value]="agreementToDischarge">{{ 'orders.agreementToDischarge' | transloco }}</mat-radio-button>
                </mat-radio-group>
            </div>
        </div>
    </form>
</div>